/**
 * Tags that Vue should treat as native custom elements (not Vue components).
 * Hotwire Turbo registers <turbo-frame> and related elements at runtime.
 */
export function isVueCustomElement(tag) {
  return tag.startsWith("turbo-")
}
